export default __webpack_public_path__ + "static/media/crown.829fd177.svg";